import { Link } from "react-router-dom";
import PageHeader from "@/components/layout/PageHeader";
import ContactBlock from "@/components/sections/ContactBlock";
import { SERVICES } from "@/lib/site";
import { ArrowUpRight, Home, Wrench, Wind, Paintbrush, Hammer, Construction, Zap, Triangle } from "lucide-react";

const ICONS = {
  home: Home,
  wrench: Wrench,
  wind: Wind,
  paintbrush: Paintbrush,
  hammer: Hammer,
  construction: Construction,
  zap: Zap,
  roof: Triangle,
};

export default function ServicesIndexPage() {
  return (
    <div data-testid="services-index-page">
      <PageHeader
        overline="Services"
        title="Full-service construction & home services."
        sub="One accountable team for ADU construction, plumbing, HVAC, drywall, remodeling and general construction across Los Angeles."
        image="https://images.pexels.com/photos/10827358/pexels-photo-10827358.jpeg"
        breadcrumbs={[{ label: "Home", to: "/" }, { label: "Services" }]}
      />

      <section className="section-pad">
        <div className="container-page grid grid-cols-1 md:grid-cols-2 gap-5">
          {SERVICES.map((s) => {
            const Icon = ICONS[s.icon] || Home;
            return (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                data-testid={`services-index-${s.slug}`}
                className="group card-base p-7 flex flex-col md:flex-row gap-6 hover:border-brand-obsidian transition-colors"
              >
                <div className="md:w-44 shrink-0 aspect-[4/3] md:aspect-square overflow-hidden rounded-sm border border-brand-line">
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                </div>
                <div className="flex-1 flex flex-col">
                  <Icon className="w-5 h-5 text-brand-olive" strokeWidth={1.75} />
                  <h2 className="heading-3 mt-4">{s.title}</h2>
                  <p className="body-sm mt-2 flex-1">{s.short}</p>
                  <span className="mt-5 inline-flex items-center gap-1 text-xs font-bold uppercase tracking-[0.2em] text-brand-ink group-hover:text-brand-olive-hover">
                    Learn more <ArrowUpRight className="w-3.5 h-3.5" />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </section>

      <ContactBlock source="services_index" />
    </div>
  );
}
